import React from 'react'
import '../style.css';

export const Preloader = () => {
  return (
    <div id='preloader'>
        <div className='loader'></div>
    </div>
  )
}
